import React, { Component } from "react";
import axios from "axios";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import { Link } from "react-router-dom";
import { Image } from "primereact/image";
import logo from "../../Assests/RebelSkool.png";
import { Fieldset } from "primereact/fieldset";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import { Button } from "primereact/button";

let userSelectedLanguage;

class UnSubscribeNewsLetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    axios
      .get(`/siteOwner/unSubscribe?token=${token}`)
      .then((res) => {
        this.setState({ isLoading: false });

        this.setState({ unsubscribed: res.data === true });
      })
      .catch(() => {
        this.setState({ unsubscribed: false });
      });
  }

  render() {
    const { isLoading } = this.state;
    return (
      <div className="Error-Main-Div">
        <NavBarHeader />
        {isLoading ? (
          <div className="ISLoading">
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "2rem" }}
            ></i>
          </div>
        ) : (
          <div className="forget-password-container">
            <center>
              <div className="forget-password-logo">
                <Link to="/">
                  <Image src={logo} alt="Image" width="200" />
                </Link>
              </div>
            </center>

            <Fieldset legend="You've successfully unsubscribed!">
              <div>
                <center>
                  <Link to="/">
                    <Button
                      label={
                        TranslationFile.backToHomeText[userSelectedLanguage]
                      }
                      aria-label={
                        TranslationFile.yearBtnSaveText[userSelectedLanguage]
                      }
                    />
                  </Link>
                </center>
              </div>
            </Fieldset>
          </div>
        )}
      </div>
    );
  }
}

export default UnSubscribeNewsLetter;
